module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-48.a35d4c38.jpg";